{
  "version": 1,
  "asset_id": "dbe9eb61-eccb-4917-be5c-4a89c37f6ebf",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/dbe9eb61-eccb-4917-be5c-4a89c37f6ebf/airtechpro-gsc-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/dbe9eb61-eccb-4917-be5c-4a89c37f6ebf/airtechpro-gsc-640.webp",
  "original_filename": "airtechpro-gsc-640.webp",
  "size": 17496,
  "content_type": "image/webp",
  "created_at": "2026-08-02T02:38:20Z"
}
